(function () {

    angular
        .module('smartertoolsApp')
        .controller('downloadsListController', ['$scope', '$timeout', 'downloadsService', downloadsListController]);

    function downloadsListController($scope, $timeout, downloadsService) {
        const vm = this;
        vm.itemsPerPage = 10;
        vm.currentPageMail = 1;
        vm.currentPageTrack = 1;
        vm.currentPageStats = 1;
        vm.reverse = true;
        vm.filteredMailItems = [];
        vm.filteredTrackItems = [];
        vm.filteredStatsItems = [];
        vm.totalFilteredMailItems = vm.filteredMailItems ? vm.filteredMailItems.length : 0;
        vm.totalFilteredTrackItems = vm.filteredTrackItems ? vm.filteredTrackItems.length : 0;
        vm.totalFilteredStatsItems = vm.filteredStatsItems ? vm.filteredStatsItems.length : 0;

        // Functions
        vm.refresh = refresh;
        vm.filter = filter;
        activate();

        // -----------------------------------------------

        function activate() {
            vm.refresh();
            $scope.$on('cache-clear', (event, data) => { refresh(); });
        }

        function refresh() {
            $scope.accountCtrl.isLoading++;
            downloadsService.getAll('smartermail', 100)
                .then((downloads) => {
                    $scope.accountCtrl.isLoading--;
                    vm.smartermailCurrentDownloads = downloads.mailVersions;
                    vm.smartertrackCurrentDownloads = downloads.trackVersions;
                    vm.smarterstatsCurrentDownloads = downloads.statsVersions;
                    vm.filter();
                })
                .catch((err) => {
                    $scope.accountCtrl.isLoading--;
                });
        }

        function filter() {
            $timeout(() => {
                vm.totalFilteredMailItems = vm.filteredMailItems ? vm.filteredMailItems.length : 0;
                vm.totalFilteredTrackItems = vm.filteredTrackItems ? vm.filteredTrackItems.length : 0;
                vm.totalFilteredStatsItems = vm.filteredStatsItems ? vm.filteredStatsItems.length : 0;
            }, 10);
        };
    }

})();